/**
 * Cookie Policy — Revision 2.1, effective July 12, 2026. Verbatim from the client's finalized document.
 */
const content = [
  {
    type: 'lead',
    text:
      'This Cookie Policy explains how KidHive, LLC. ("KidHive," "we," "us") uses cookies and similar technologies on the KidHive website and web app (the "Service"). It expands on Section 6 of our Privacy Policy; the two should be read together. Questions: info@KidHive.co.',
  },

  { type: 'h2', text: 'What these technologies are' },
  {
    type: 'p',
    text:
      'Cookies are small text files stored on your device when you use a website or web app. We and a few partners also use related tools — pixels, web beacons, and local storage — that work much like cookies. We refer to all of them together as "cookies" in this policy. They let the Service recognize your device, remember your preferences, and understand how the Service is used.',
  },

  { type: 'h2', text: 'Why we use them' },
  {
    type: 'p',
    text:
      'We use cookies to keep the Service running and secure, remember your settings and sign-in, and understand which features people use so we can improve them.',
  },

  { type: 'h2', text: 'The categories we use' },
  {
    type: 'p',
    text:
      "**Essential.** Required for the Service to work — things like signing you in, keeping your session secure, and remembering items as you move through the Service. These can't be switched off through our tools without breaking core functionality.",
  },
  {
    type: 'p',
    text:
      '**Functional.** Remember choices you make (like your location or notification preferences) to give you a smoother, more personalized experience.',
  },
  {
    type: 'p',
    text:
      "**Analytics / performance.** Help us see how the Service is used — which screens are visited, what's slow, where people run into trouble — so we can make it better. We use providers such as Google Analytics for this.",
  },
  {
    type: 'p',
    text:
      'We do **not** use cookies for third-party or cross-context behavioral advertising, and we do not apply analytics cookies to any information that relates to a child.',
  },

  { type: 'h2', text: 'Third parties' },
  {
    type: 'p',
    text:
      "Some cookies are set by partners who provide analytics and content delivery on our behalf. Their use of information they collect is governed by their own privacy and cookie policies. We don't sell your personal information, and we don't share it for cross-context behavioral advertising.",
  },

  { type: 'h2', text: 'Your choices' },
  {
    type: 'p',
    text:
      '**Browser controls.** Most browsers let you block or delete cookies through their settings. Blocking essential cookies may stop parts of the Service from working.',
  },
  {
    type: 'p',
    text:
      '**Opt-out preference signals.** We honor recognized opt-out signals, such as Global Privacy Control (GPC), where applicable.',
  },
  {
    type: 'p',
    text:
      '**Do Not Track.** Some browsers send a "Do Not Track" signal. There\'s no industry-standard response to it yet; we describe our actual practices in this policy and our Privacy Policy.',
  },

  { type: 'h2', text: 'Updates' },
  {
    type: 'p',
    text:
      'We may update this Cookie Policy as our practices or the technologies change. We\'ll revise the "Effective" date above and, where appropriate, give notice in the Service.',
  },

  { type: 'h2', text: 'Contact' },
  { type: 'contact', lines: ['KidHive, LLC.', 'info@KidHive.co'] },
];

export default content;
